import { isNgTemplate } from '@angular/compiler';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import { DigitalDataService } from 'ib-web-commons/dist/app/core/ib-datalayer/services/ib-digital-data-service';
import { BaggageDatalayerUtils } from './ib-baggage-datalayer-utils';
import { SeatsDatalayerUtils } from './ib-seats-datalayer-utils';
import { InsuranceDatalayerUtils } from './ib-insurance-datalayer-utils';
import { FlexibilizationDatalayerUtils } from './ib-flexibilization-datalayer-utils';
import { SpeqsDatalayerUtils } from './ib-speqs-datalayer-utils';
import { PriorityDatalayerUtils } from './ib-priority-datalayer-utils';
import { BundlesDatalayerUtils } from './ib-bundles-datalayer-utils';
import { DatalayerHelper } from './ib-datalayer-helper';
import * as ancillariesInfo   from '../core/models/ancillaries-info';
import isEqual from 'lodash-es/isEqual.js';
import omit from 'lodash-es/omit.js';
import { IbInsuranceAllianzDatalayerUtilsService } from './ib-insurance-allianz-datalayer-utils.service';

@Service('ib-web-ancillaries-module',
    ['localStorageService', 'DatalayerConstants', 'CommonsUtilService', 'DigitalDataService', 'AncillariesConstants', 'DatalayerUtilsService', 'BaggageDatalayerUtils', 'SeatsDatalayerUtils', 'InsuranceDatalayerUtils', 'FlexibilizationDatalayerUtils', 'SpeqsDatalayerUtils', 'PriorityDatalayerUtils', 'BundlesDatalayerUtils', 'DatalayerHelper', 'IbInsuranceAllianzDatalayerUtilsService'],
    ['ib-commons-constants-module', 'ib-monetate-module'])
export class DatalayerUtils {
    seatSelectedId: string[] = [];
    seatSelectedType: string[] = [];
    segmentId: string;
    constructor (
        private localStorageService: angular.local.storage.ILocalStorageService,
        private DatalayerConstants: DatalayerConstantsType,
        private CommonsUtilService: CommonsUtilService,
        private DigitalDataService: DigitalDataService,
        private AncillariesConstants: AncillariesConstant,
        private DatalayerUtilsService: DatalayerUtilsService,
        private BaggageDatalayerUtils: BaggageDatalayerUtils,
        private SeatsDatalayerUtils: SeatsDatalayerUtils,
        private InsuranceDatalayerUtils: InsuranceDatalayerUtils,
        private FlexibilizationDatalayerUtils: FlexibilizationDatalayerUtils,
        private SpeqsDatalayerUtils: SpeqsDatalayerUtils,
        private PriorityDatalayerUtils: PriorityDatalayerUtils,
        private BundlesDatalayerUtils: BundlesDatalayerUtils,
        private DatalayerHelper: DatalayerHelper,
        private IbInsuranceAllianzDatalayerUtilsService: IbInsuranceAllianzDatalayerUtilsService
    ) { }

    getAncillariesDigitalDataEcommerce = (typeAncillaries: string, event: string): void => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const ancillariesInfo: any = this.localStorageService.get('ancillariesInfo');
        if (ancillariesInfo) {
            const id = this.CommonsUtilService.getIdItem('all');
            ancillariesInfo?.ancillaries.forEach(anc => {
                switch (`${typeAncillaries}-${anc.type}`) {
                        case 'baggages-BAGGAGE':
                            const {slices: baggagesInfo} = ancillariesInfo.ancillaries.find(anc => anc.type === 'BAGGAGE');
                            baggagesInfo.forEach(baggageInfo => {
                                baggageInfo?.passengers[0]?.pieces.forEach(piece => {
                                    const item = this.BaggageDatalayerUtils.getDataEcommerceForBaggage('baggage', piece, baggageInfo);
                                    digital_data_ecommerce.items.push(item);
                                });
                            });
                            break;
                        case 'seat-SEAT':
                            const seatMap: any = this.localStorageService.get('seatMap');
                            seatMap?.seatPriceInfo?.seatPrices?.forEach(seatPrice => {
                                const item = this.SeatsDatalayerUtils.getDataEcommerceForSeats(seatPrice, anc);
                                digital_data_ecommerce.items.push(item);
                            });
                            break;
                        case 'insurance-INSURANCE':
                            anc.offers.forEach(offer => {
                                const item: DigitalDataEcommerceModel.Item = this.InsuranceDatalayerUtils.getDataEcommerceForInsurance('insurance', anc, offer);
                                digital_data_ecommerce.items.push(item);
                            });
                            break;
                        case 'insurance-ALLIANZ_FUSION':
                            anc.products.forEach(product => {
                                const item: DigitalDataEcommerceModel.Item = this.IbInsuranceAllianzDatalayerUtilsService.setInsuranceEcommerceViewItem('insurance', product);
                                digital_data_ecommerce.items.push(item);
                            });
                            break;
                        case 'flexibilization-FLEXIBILITY_ON_DEMAND':
                            anc.flexibilityAncillaries.forEach(offer => {
                                const item = this.FlexibilizationDatalayerUtils.getDataEcommerceForFlexibilization('flexible_ticket', offer);
                                digital_data_ecommerce.items.push(item);
                            });
                            break;
                        case 'special baggages-SPECIAL_EQUIPMENT':
                            anc.slices.forEach(slice => {
                                slice?.passengers[0]?.pieces.forEach(piece => {
                                    const item = this.SpeqsDatalayerUtils.getDataEcommerceForSpecialBaggage('special baggage', slice, piece);
                                    digital_data_ecommerce.items.push(item);
                                });
                            });
                            break;
                        case 'priority boarding-PRIORITY_BOARDING':
                            anc.segments.forEach(segment => {
                                const item = this.PriorityDatalayerUtils.getDataEcommerceForPriorityBoarding(segment);
                                digital_data_ecommerce.items.push(item);
                            });
                            break;
                }
            });

            if(typeAncillaries === this.AncillariesConstants.DATALAYER_INFO.BUNDLE) {
                const bookingInfo: any = this.localStorageService.get('bookingInfo');
                const passAndSlices = bookingInfo.passengers.length * ancillariesInfo.slices.length;
                ancillariesInfo.bundles.forEach((bundle: any) => {
                    bundle.allDiscountByPassAndSlice = bundle.priceItemsAllDiscount / passAndSlices;
                    const item = this.BundlesDatalayerUtils.getDataEcommerceForBundle(bundle);
                    digital_data_ecommerce.items.push(item);
                });
            }
        }

        if (digital_data_ecommerce.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(digital_data_ecommerce, event);
        }
    };

    setBaggagesSelectItem = (trip: any, baggageTypeSelected: any): void => {

        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const item = this.BaggageDatalayerUtils.setBaggagesSelectItem(trip, baggageTypeSelected);
        digital_data_ecommerce.items.push(item);
        if (digital_data_ecommerce.items.length > 0) this.DigitalDataService.addDigitalDataEcommerceEvent(digital_data_ecommerce, this.DatalayerConstants.EVENTS_ECOMMERCE.SELECT_ITEM);
    };

    setSelectItemAndAddToCartBundle (selectedBundle: any): void {
        const selectedTripInfo: any = this.localStorageService.get('selectedTripInfo');
        const id = this.CommonsUtilService.getIdItem('all');
        const digital_data_ecommerce_select_item: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const digital_data_ecommerce_add_to_cart: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const item: DigitalDataEcommerceModel.Item = {
            item_name: this.AncillariesConstants.DATALAYER_INFO.BUNDLE,
            item_id: id,
            price: selectedBundle.priceItemsDiscount,
            item_brand: selectedTripInfo ? selectedTripInfo[0].info.segments[0].flight.operationalCarrier.name.toLowerCase() : this.DatalayerHelper.getBrandItem(id, null),
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: 'all',
            item_category3: 'all',
            item_variant: selectedBundle.id
        };
        digital_data_ecommerce_select_item.items.push(item);
        digital_data_ecommerce_add_to_cart.items.push(item);

        selectedBundle.items.forEach((itemBundle: any) => {
            const item: DigitalDataEcommerceModel.Item = {
                item_name: this.getBundleItemTypeName(itemBundle.type),
                item_id: id,
                price: itemBundle.priceItemDiscount,
                item_brand: selectedTripInfo ? selectedTripInfo[0].info.segments[0].flight.operationalCarrier.name.toLowerCase() : this.DatalayerHelper.getBrandItem(id, null),
                item_category: this.DatalayerHelper.getItemCategory(),
                item_category2: '',
                item_category3: '',
                item_variant: this.getBundleItemSubtypeName(itemBundle.subtype)
            };

            digital_data_ecommerce_add_to_cart.items.push(item);
        });


        if (digital_data_ecommerce_select_item.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(digital_data_ecommerce_select_item, this.DatalayerConstants.EVENTS_ECOMMERCE.SELECT_ITEM);
            this.DigitalDataService.addDigitalDataEcommerceEvent(digital_data_ecommerce_add_to_cart, this.DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART);
            this.DigitalDataService.setAddInfoAddToCart(digital_data_ecommerce_add_to_cart);
        }
    }

    private getBundleItemTypeName (type: string): string {
        switch(type) {
                case this.AncillariesConstants.TYPE_ANCILLARIE.BAGGAGE:
                    return this.AncillariesConstants.DATALAYER_INFO.BAGGAGE;
                case this.AncillariesConstants.TYPE_ANCILLARIE.SPEQS:
                    return this.AncillariesConstants.DATALAYER_INFO.SPECIAL_EQUIPMENT;
                case this.AncillariesConstants.TYPE_ANCILLARIE.FLEXIBILITY:
                    return this.AncillariesConstants.DATALAYER_INFO.FLEXIBILITY_ON_DEMAND;
                case this.AncillariesConstants.TYPE_ANCILLARIE.PRIORITY_BOARDING:
                    return this.AncillariesConstants.DATALAYER_INFO.PRIORITY_BOARDING;
        }
    }

    private getBundleItemSubtypeName (subtype: string): string {
        switch(subtype) {
                case this.AncillariesConstants.ANCILLARIES_SUBTYPES.BAGGAGE_15:
                    return this.AncillariesConstants.DATALAYER_INFO.BAGGAGE + ' 15Kg';
                case this.AncillariesConstants.ANCILLARIES_SUBTYPES.BAGGAGE_23:
                    return this.AncillariesConstants.DATALAYER_INFO.BAGGAGE + ' 23Kg';
                case this.AncillariesConstants.ANCILLARIES_SUBTYPES.BAGGAGE_32:
                    return this.AncillariesConstants.DATALAYER_INFO.BAGGAGE + ' 32Kg';

                case this.AncillariesConstants.ANCILLARIES_SUBTYPES.BICYCLE:
                    return this.AncillariesConstants.DATALAYER_INFO.BICYCLE;
                case this.AncillariesConstants.ANCILLARIES_SUBTYPES.GOLF_EQUIPMENT:
                    return this.AncillariesConstants.DATALAYER_INFO.GOLF_EQUIPMENT;
                case this.AncillariesConstants.ANCILLARIES_SUBTYPES.SKI_SNOW:
                    return this.AncillariesConstants.DATALAYER_INFO.SKI_SNOW;

                case this.AncillariesConstants.ANCILLARIES_SUBTYPES.FLEXIBILITY_PACK:
                    return this.AncillariesConstants.DATALAYER_INFO.FLEXIBILITY_PACK;
                case this.AncillariesConstants.ANCILLARIES_SUBTYPES.FLIGHT_CHANGE:
                    return this.AncillariesConstants.DATALAYER_INFO.FLIGHT_CHANGE;
                case this.AncillariesConstants.ANCILLARIES_SUBTYPES.VOUCHER_REFUND:
                    return this.AncillariesConstants.DATALAYER_INFO.VOUCHER_REFUND;
                default:
                    return this.AncillariesConstants.DATALAYER_INFO.PRIORITY_BOARDING;
        }
    }

    setBaggagesEventCart = (model: any): void => {
        let digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        let itemsToAdd: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        let itemsToRemove: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const addToCart: DigitalDataEcommerceModel.ViewItemList = this.DatalayerHelper.getItemAddToCartByItemName('baggage');

        digital_data_ecommerce = this.BaggageDatalayerUtils.setBaggagesEventCart(model);

        itemsToAdd = this.DatalayerHelper.getItemsToAddOrRemove(addToCart, digital_data_ecommerce, true);
        itemsToRemove = this.DatalayerHelper.getItemsToAddOrRemove(addToCart, digital_data_ecommerce, false);
        if (itemsToAdd.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(itemsToAdd, this.DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART);
            this.DigitalDataService.setAddInfoAddToCart(itemsToAdd);
        }
        if (itemsToRemove.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(itemsToRemove, this.DatalayerConstants.EVENTS_ECOMMERCE.REMOVE_FROM_CART);
            this.DigitalDataService.setRemoveInfoAddToCart(itemsToRemove);
        }
    };

    setBaggagesRemoveFromCart = (trip: any, baggageTypeSelected: any): void => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const item =this.BaggageDatalayerUtils.setBaggagesRemoveFromCart(trip, baggageTypeSelected);
        digital_data_ecommerce.items.push(item);
        if (digital_data_ecommerce.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(digital_data_ecommerce, this.DatalayerConstants.EVENTS_ECOMMERCE.REMOVE_FROM_CART);
        }
    };

    setSeatSelectItem = (model: any, seatSelected: any): void => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const item = this.SeatsDatalayerUtils.setSeatSelectItem(model, seatSelected);
        digital_data_ecommerce.items.push(item);
        if (digital_data_ecommerce.items.length > 0 && (!this.seatSelectedId.includes(seatSelected.id) || !this.seatSelectedType.includes(seatSelected.seatType))) {
            this.seatSelectedId.push(seatSelected.id);
            this.seatSelectedType.push(seatSelected.seatType);
            this.DigitalDataService.addDigitalDataEcommerceEvent(digital_data_ecommerce, this.DatalayerConstants.EVENTS_ECOMMERCE.SELECT_ITEM);
        }
    };

    setRemoveSeatSelectedId = (): void => {
        this.seatSelectedId = [];
        this.seatSelectedType = [];
    };

    setSeatAddToCart = (model: any): void => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList= this.SeatsDatalayerUtils.setSeatAddToCart(model);
        const addToCart: DigitalDataEcommerceModel.ViewItemList = this.DatalayerHelper.getItemAddToCartByItemName('seat');
        let itemsToAdd: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        let itemsToRemove: DigitalDataEcommerceModel.ViewItemList = { items: [] };

        itemsToAdd = this.DatalayerHelper.getItemsToAddOrRemove(addToCart, digital_data_ecommerce, true);
        itemsToRemove = this.DatalayerHelper.getItemsToAddOrRemove(addToCart, digital_data_ecommerce, false);

        if (itemsToAdd.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(itemsToAdd, this.DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART);
            this.DigitalDataService.setAddInfoAddToCart(itemsToAdd);
        }
        if (itemsToRemove.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(itemsToRemove, this.DatalayerConstants.EVENTS_ECOMMERCE.REMOVE_FROM_CART);
            this.DigitalDataService.setRemoveInfoAddToCart(itemsToRemove);
        }
    };
    //TODO: if not use delete
    setInsuranceEcommerce = (insurance: any, event: string) => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const id = this.CommonsUtilService.getIdItem('all');
        const item_brand = insurance?.provider ? insurance.provider.toLowerCase() : 'null';
        const item: DigitalDataEcommerceModel.Item = {
            item_name: 'insurance',
            item_id: id,
            price: insurance.originalPrice,
            item_brand: item_brand,
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: 'all',
            item_category3: 'all',
            item_variant: insurance?.id.toLowerCase(),
            quantity: 1
        };
        digital_data_ecommerce.items.push(item);
        if (digital_data_ecommerce.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(digital_data_ecommerce, event);
            if (event === this.DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART && !this.CommonsUtilService.checkIsAddToCart('insurance')) {
                this.DigitalDataService.setAddInfoAddToCart(digital_data_ecommerce);
            } else {
                this.DigitalDataService.setRemoveInfoAddToCart(digital_data_ecommerce);
            }
        }

    };

    setPriorityBoardingSelectItem = (tripInfo: any) => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const item = this.PriorityDatalayerUtils.setPriorityBoardingSelectItem(tripInfo);
        digital_data_ecommerce.items.push(item);
        if (digital_data_ecommerce.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(digital_data_ecommerce, 'select_item');
        }
    };

    /*
     ** Set Priority Boarding AddToCart or RemoveFromCart datalayer events as appropriate
     */
    setPriorityBoardingAddToCart = (segments: any, info: any) => {
        const {digital_data_ecommerce, itemsToRemove} = this.PriorityDatalayerUtils.setPriorityBoardingAddToCart(segments, info);
        if (digital_data_ecommerce.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(digital_data_ecommerce, this.DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART);
            this.DigitalDataService.setAddInfoAddToCart(digital_data_ecommerce);
        }
        if (itemsToRemove.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(itemsToRemove, this.DatalayerConstants.EVENTS_ECOMMERCE.REMOVE_FROM_CART);
            this.DigitalDataService.setRemoveInfoAddToCart(itemsToRemove);
        }
    };

    setFlexibilizationSelectItem = (flex: AncillariesModel.AncillaryInfo): void => {
        let digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        digital_data_ecommerce = this.FlexibilizationDatalayerUtils.setFlexibilizationSelectItem(flex);
        if (digital_data_ecommerce.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(digital_data_ecommerce, this.DatalayerConstants.EVENTS_ECOMMERCE.SELECT_ITEM);
        }
    };

    setFlexibilizationAddToCart = (selectedFlex) => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = this.FlexibilizationDatalayerUtils.setFlexibilizationSelectItem(selectedFlex);
        if (digital_data_ecommerce.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(digital_data_ecommerce, this.DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART);
            this.DigitalDataService.setAddInfoAddToCart(digital_data_ecommerce);
        }
    };

    setSpeqsSelectItem = (trip: any, piece: any): void => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = this.SpeqsDatalayerUtils.setSpeqsSelectItem(trip, piece);
        if (digital_data_ecommerce.items.length > 0) this.DigitalDataService.addDigitalDataEcommerceEvent(digital_data_ecommerce, this.DatalayerConstants.EVENTS_ECOMMERCE.SELECT_ITEM);
    };

    setSpeqsEventCart = (model: any): void => {
        const {itemsToAdd, itemsToRemove} = this.SpeqsDatalayerUtils.setSpeqsEventCart(model);
        if (itemsToAdd.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(itemsToAdd, this.DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART);
            this.DigitalDataService.setAddInfoAddToCart(itemsToAdd);
        }
        if (itemsToRemove.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(itemsToRemove, this.DatalayerConstants.EVENTS_ECOMMERCE.REMOVE_FROM_CART);
            this.DigitalDataService.setRemoveInfoAddToCart(itemsToRemove);
        }
    };

    bobEcommerceEventSelected = (model: any) => {
        this.bobEcommerceEvent(this.DatalayerConstants.EVENTS_ECOMMERCE.SELECT_ITEM, model);
    };

    bobEcommerceEventView = () => {
        this.bobEcommerceEvent(this.DatalayerConstants.EVENTS_ECOMMERCE.VIEW_ITEM_LIST);
    };

    bobEcommerceEventAddToCard = (model: any) => {
        this.bobEcommerceEvent(this.DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART, model);
    };

    private bobEcommerceEvent = (eventType: string, model?: any): void => {
        const flowApp = this.localStorageService.get('flowApp');
        const segmentsSelected: any[] = this.localStorageService.get('segmentsSelected');
        const ancillariesInfo: any = this.localStorageService.get('ancillariesInfo');
        const bobInfo: any = this.localStorageService.get('bobInfo');
        let ancillariesAvailableSegments: string [] = [];
        if(flowApp !== 'MMB') {
            ancillariesAvailableSegments = this.localStorageService.get('ancillariesAvailableSegments');
        } else {
            const baggageAvailable: string[] = this.localStorageService.get('baggagesAvailableSegments');
            const ancillariesSlices: any[] = this.localStorageService.get('ancillariesSlices');
            baggageAvailable?.forEach(sliceId => {
                const sliceSelected = ancillariesSlices.find((ancillarie) => ancillarie.id === sliceId);
                sliceSelected.segmentIds.forEach((segment) => {
                    ancillariesAvailableSegments.push(segment);
                });
            });
        }
        const digitalDataEcommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const isEventAddToCart: boolean = (eventType === this.DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART);
        let itemsToAdd: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        let itemsToRemove: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        let addToCart: DigitalDataEcommerceModel.ViewItemList = null;

        if (isEventAddToCart) {
            addToCart = this.DatalayerHelper.getItemAddToCartByItemName('bob');
        }

        ancillariesAvailableSegments.forEach((strId: string) => {
            let segment;
            if(flowApp === 'MMB') {
                segment = segmentsSelected.find(seg => seg.segmentId === strId);
            } else {
                segment = segmentsSelected.find(seg => seg.id === Number(strId));
            }
            const airportCodeArrival: string = segment?.arrival?.airportCode ? segment.arrival.airportCode : '';
            const airportCodeDeparture: string = segment?.departure?.airportCode ? segment.departure.airportCode : '';
            const airlineName: string = segment?.airlineName ? segment.airlineName : '';

            ancillariesInfo.slices.forEach(slice => {
                if (bobInfo && slice.segmentIds.includes(flowApp !== 'MMB' ? segment?.id?.toString() : segment?.segmentId?.toString())) {
                    const bobSlice = bobInfo.slices.find(sliceBob => sliceBob.sliceId === slice.id);
                    if (bobSlice) {
                        const freeBagsIncluded = (Array.isArray(bobSlice.products) && bobSlice.products.length > 0 && bobSlice.products[0].freeBagsIncluded) ? bobSlice.products[0].freeBagsIncluded : 0;
                        const quantity = model?.numBagsTotal ? model.numBagsTotal : freeBagsIncluded;
                        let price = (Array.isArray(bobSlice.products) && bobSlice.products.length > 0) ? bobSlice.products[0].price : 0;
                        if (model?.priceTotal && quantity > 1) {
                            price = model.priceTotal / quantity;
                        }
                        const item: DigitalDataEcommerceModel.Item = {
                            item_name: 'bob',
                            item_id: `${airportCodeDeparture}-${airportCodeArrival}`,
                            price: price,
                            item_brand: airlineName,
                            item_category: this.DatalayerHelper.getItemCategory(),
                            item_category2: 'all',
                            item_category3: 'all',
                            item_variant: '1maleta',
                            quantity: quantity
                        };

                        digitalDataEcommerce.items.push(item);
                    }
                }
            });
            if (isEventAddToCart) {
                itemsToAdd = this.DatalayerHelper.getItemsToAddOrRemove(addToCart, digitalDataEcommerce, true);
            }
        });
        if (digitalDataEcommerce.items?.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(digitalDataEcommerce, eventType);
            //this.DigitalDataService.setAddInfoAddToCart(digitalDataEcommerce);
            if (isEventAddToCart) {
                itemsToRemove = this.DatalayerHelper.getItemsToAddOrRemove(addToCart, digitalDataEcommerce, false);
                if (itemsToAdd.items.length > 0) {
                    this.DigitalDataService.addDigitalDataEcommerceEvent(itemsToAdd, this.DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART);
                    this.DigitalDataService.setAddInfoAddToCart(itemsToAdd);
                }
                if (itemsToRemove.items.length > 0) {
                    this.DigitalDataService.addDigitalDataEcommerceEvent(itemsToRemove, this.DatalayerConstants.EVENTS_ECOMMERCE.REMOVE_FROM_CART);
                    this.DigitalDataService.setRemoveInfoAddToCart(itemsToRemove);
                }
            }
        }

    };

    setTransferEvent (eventType: string, transferCar: string, priceGoing: number, priceReturn: number, segments: any): void {
        const digitalDataEcommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const trip: string = this.CommonsUtilService.getIdItem();

        const itemOneWay: DigitalDataEcommerceModel.Item = {
            item_name: 'traslado',
            item_id: trip,
            price: priceGoing,
            item_brand: 'globick',
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: trip.substring(0, trip.indexOf('|')),
            item_category3: '1',
            item_variant: transferCar,
            quantity: 1
        };

        digitalDataEcommerce.items.push(itemOneWay);

        if(priceReturn) {
            const itemReturn: DigitalDataEcommerceModel.Item = {
                item_name: 'traslado',
                item_id: trip,
                price: priceReturn,
                item_brand: 'globick',
                item_category: this.DatalayerHelper.getItemCategory(),
                item_category2: trip.substring(trip.indexOf('|') + 1, trip.length),
                item_category3: '2',
                item_variant: transferCar,
                quantity: 1
            };
            digitalDataEcommerce.items.push(itemReturn);
        }

        if (eventType === this.DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(digitalDataEcommerce, eventType);
            this.DigitalDataService.setAddInfoAddToCart(digitalDataEcommerce);
        }
    }

    setActivitiesEvent (eventType: string, price: [number], activity: [string]): void {
        const digitalDataEcommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const trip: string = this.CommonsUtilService.getIdItem();
        const segment = trip.substring(0, trip.indexOf('|'));
        const city = segment.substring(segment.indexOf('-') + 1, segment.length);
        const bookingInfo: any = this.localStorageService.get('bookingInfo');

        const addToCart: DigitalDataEcommerceModel.ViewItemList = this.DatalayerHelper.getItemAddToCartByItemName('actividades');

        const activityItem: DigitalDataEcommerceModel.Item = {
            item_name: 'actividades',
            item_id: city,
            price: price[0],
            item_brand: 'globick',
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: 'all',
            item_category3: 'all',
            item_variant: activity[0],
            quantity: bookingInfo.passengers.length
        };

        digitalDataEcommerce.items.push(activityItem);

        if (eventType === this.DatalayerConstants.EVENTS_ECOMMERCE.SELECT_ITEM) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(digitalDataEcommerce, eventType);
        } else if (eventType === this.DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(digitalDataEcommerce, eventType);
            this.DigitalDataService.setAddInfoAddToCart(digitalDataEcommerce);
        } else if (eventType === this.DatalayerConstants.EVENTS_ECOMMERCE.REMOVE_FROM_CART) {
            const itemToRemove = addToCart.items.filter((item: DigitalDataEcommerceModel.Item) =>
                item.item_variant === activity[0]);
            this.DigitalDataService.addDigitalDataEcommerceEvent({items: itemToRemove}, this.DatalayerConstants.EVENTS_ECOMMERCE.REMOVE_FROM_CART);
            this.DigitalDataService.setRemoveInfoAddToCart({items: itemToRemove});
        }

    }
}